import {
  ChargerGroupsState,
  DefaultGroupFilterValues,
} from './charger-group.models';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import { createReducer, on } from '@ngrx/store';
import * as chargerGroupActions from './charger-group.actions';

export const chargerGroupsInitialState: ChargerGroupsState = {
  chargerGroups: [],
  chargerGroupFilterValues: {
    maxChargers: DefaultGroupFilterValues.maxChargers,
    maxConnectors: DefaultGroupFilterValues.maxConnectors,
    maxEnergy: DefaultGroupFilterValues.maxEnergy,
    maxTransactions: DefaultGroupFilterValues.maxTransactions,
  },
  currentGroupsFilter: null,
  chargerGroupsPage: null,
  pagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  loading: false,
  error: null,
  groupOverview: null
};

export const chargerGroupsReducer = createReducer(
  chargerGroupsInitialState,
  on(chargerGroupActions.loadChargerGroupList, (state) => ({
    ...state,
    loading: true,
  })),
  on(chargerGroupActions.loadChargerGroupListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'Error',
  })),
  on(
    chargerGroupActions.loadChargerGroupListSuccess,
    (state, { chargerGroupsResponse }) => ({
      ...state,
      loading: false,
      error: null,
      chargerGroups: chargerGroupsResponse.result ?? [],
      chargerGroupsPage: {
        ...state.chargerGroupsPage,
        totalCount: chargerGroupsResponse.total ?? 0,
        pageIndex: chargerGroupsResponse.pageIndex ?? 0,
        pageSize: chargerGroupsResponse.pageSize ?? 0,
      },
    })
  ),
  on(
    chargerGroupActions.changePagination,
    (state, { pageIndex, pageSize }) => ({
      ...state,
      pagination: {
        pageIndex,
        pageSize,
      },
    })
  ),
  on(chargerGroupActions.loadFilterOptionsSuccess, (state, filter) => ({
    ...state,
    chargerGroupFilterValues: filter
      ? {
          maxChargers: filter.filterValues!.maxNumOfChargers!,
          maxConnectors: filter.filterValues!.maxNumOfConnectors!,
          maxEnergy: filter.filterValues!.maxEnergyInLast30Days!,
          maxTransactions:
            filter.filterValues!.maxNumberOfTransactionsInLast30Days!,
        }
      : null,
  })),
  on(chargerGroupActions.updateCurrentGroupFilter, (state, filter) => ({
    ...state,
    currentGroupsFilter: { ...filter.filter },
  })),
  on(chargerGroupActions.chargerGroupLoadSuccess, (state, payload) => ({
    ...state,
    groupOverview : payload.group,
  })), 
  on(chargerGroupActions.chargerGroupUpdateSuccess, (state, payload) => ({
    ...state,
    groupOverview : payload.group,
  }))
);
